var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.point)?_c('circle',{ref:"control-point",staticClass:"cursor-move",attrs:{"cx":_vm.point.x,"cy":_vm.point.y,"r":"10","stroke":"rgba(255,0,0,0.5)","fill":"rgb(255, 0,0, 1)"},on:{"mousedown":_vm.onMD}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }